import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: css({
        paddingBlock: '20px',
        gap: '40px',
        order: 1,
    }),
    userDetailsContainer: css({
        marginTop: '-30px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    }),
    spanishTaxDetailsContainer: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    }),
    addressDetailsContainer: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    }),
    addressSubtitle: css({
        marginBottom: '10px',
        display: 'flex',
        alignItems: 'center',
        gap: '7px',
    }),
    inputGroupWrapper: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        [theme.breakpoints.up('lg')]: {
            flexDirection: 'row',
        },
    }),
    cta: css({
        borderRadius: '100px',
        paddingBlock: '16px',
        width: isHosTheme ? '390px' : '100%',
        maxWidth: '100%',
    }),
};
